const countryCode = [
  {
    en: 'Angola',
    zh: '安哥拉',
    tw: '安哥拉',
    locale: 'AO',
    code: 244,
  },
  {
    en: 'Afghanistan',
    zh: '阿富汗',
    tw: '阿富汗',
    locale: 'AF',
    code: 93,
  },
  {
    en: 'Albania',
    zh: '阿尔巴尼亚',
    tw: '阿爾巴尼亞',
    locale: 'AL',
    code: 355,
  },
  {
    en: 'Algeria',
    zh: '阿尔及利亚',
    tw: '阿爾及利亞',
    locale: 'DZ',
    code: 213,
  },
  {
    en: 'Andorra',
    zh: '安道尔共和国',
    tw: '安道爾共和國',
    locale: 'AD',
    code: 376,
  },
  {
    en: 'Anguilla',
    zh: '安圭拉岛',
    tw: '安圭拉島',
    locale: 'AI',
    code: 1264,
  },
  {
    en: 'Antigua and Barbuda',
    zh: '安提瓜和巴布达',
    tw: '安提瓜和巴布達',
    locale: 'AG',
    code: 1268,
  },
  {
    en: 'Argentina',
    zh: '阿根廷',
    tw: '阿根廷',
    locale: 'AR',
    code: 54,
  },
  {
    en: 'Armenia',
    zh: '亚美尼亚',
    tw: '亞美尼亞',
    locale: 'AM',
    code: 374,
  },
  {
    en: 'Ascension',
    zh: '阿森松',
    tw: '阿森松',
    locale: ' ',
    code: 247,
  },
  {
    en: 'Australia',
    zh: '澳大利亚',
    tw: '澳大利亞',
    locale: 'AU',
    code: 61,
  },
  {
    en: 'Austria',
    zh: '奥地利',
    tw: '奧地利',
    locale: 'AT',
    code: 43,
  },
  {
    en: 'Azerbaijan',
    zh: '阿塞拜疆',
    tw: '阿塞拜疆',
    locale: 'AZ',
    code: 994,
  },
  {
    en: 'Bahamas',
    zh: '巴哈马',
    tw: '巴哈馬',
    locale: 'BS',
    code: 1242,
  },
  {
    en: 'Bahrain',
    zh: '巴林',
    tw: '巴林',
    locale: 'BH',
    code: 973,
  },
  {
    en: 'Bangladesh',
    zh: '孟加拉',
    tw: '孟加拉',
    locale: 'BD',
    code: 880,
  },
  {
    en: 'Barbados',
    zh: '巴巴多斯',
    tw: '巴巴多斯',
    locale: 'BB',
    code: 1246,
  },
  {
    en: 'Belarus',
    zh: '白俄罗斯',
    tw: '白俄羅斯',
    locale: 'BY',
    code: 375,
  },
  {
    en: 'Belgium',
    zh: '比利时',
    tw: '比利時',
    locale: 'BE',
    code: 32,
  },
  {
    en: 'Belize',
    zh: '伯利兹',
    tw: '伯利茲',
    locale: 'BZ',
    code: 501,
  },
  {
    en: 'Benin',
    zh: '贝宁',
    tw: '貝寧',
    locale: 'BJ',
    code: 229,
  },
  {
    en: 'Bermuda Is.',
    zh: '百慕大群岛',
    tw: '百慕大群島',
    locale: 'BM',
    code: 1441,
  },
  {
    en: 'Bolivia',
    zh: '玻利维亚',
    tw: '玻利維亞',
    locale: 'BO',
    code: 591,
  },
  {
    en: 'Botswana',
    zh: '博茨瓦纳',
    tw: '博茨瓦納',
    locale: 'BW',
    code: 267,
  },
  {
    en: 'Brazil',
    zh: '巴西',
    tw: '巴西',
    locale: 'BR',
    code: 55,
  },
  {
    en: 'Brunei',
    zh: '文莱',
    tw: '汶萊',
    locale: 'BN',
    code: 673,
  },
  {
    en: 'Bulgaria',
    zh: '保加利亚',
    tw: '保加利亞',
    locale: 'BG',
    code: 359,
  },
  {
    en: 'Burkina-faso',
    zh: '布基纳法索',
    tw: '布基納法索',
    locale: 'BF',
    code: 226,
  },
  {
    en: 'Burma',
    zh: '缅甸',
    tw: '緬甸',
    locale: 'MM',
    code: 95,
  },
  {
    en: 'Burundi',
    zh: '布隆迪',
    tw: '布隆迪',
    locale: 'BI',
    code: 257,
  },
  {
    en: 'Cameroon',
    zh: '喀麦隆',
    tw: '喀麥隆',
    locale: 'CM',
    code: 237,
  },
  {
    en: 'Cayman Is.',
    zh: '开曼群岛',
    tw: '開曼群島',
    locale: ' ',
    code: 1345,
  },
  {
    en: 'Central African Republic',
    zh: '中非共和国',
    tw: '中非共和國',
    locale: 'CF',
    code: 236,
  },
  {
    en: 'Chad',
    zh: '乍得',
    tw: '乍得',
    locale: 'TD',
    code: 235,
  },
  {
    en: 'Chile',
    zh: '智利',
    tw: '智利',
    locale: 'CL',
    code: 56,
  },
  {
    en: 'China',
    zh: '中国大陆',
    tw: '中國大陸',
    locale: 'CN',
    code: 86,
    common: 'common',
  },
  {
    en: 'Hongkong',
    zh: '中国香港',
    tw: '中國香港',
    locale: 'HK',
    code: 852,
    common: 'common',
  },
  {
    en: 'Taiwan',
    zh: '中国台湾',
    tw: '中國臺灣',
    locale: 'TW',
    code: 886,
    common: 'common',
  },
  {
    en: 'United States of America',
    zh: '美国',
    tw: '美國',
    locale: 'US',
    code: 1,
    common: 'common',
  },
  {
    en: 'Canada',
    zh: '加拿大',
    tw: '加拿大',
    locale: 'CA',
    code: 1,
  },
  {
    en: 'Colombia',
    zh: '哥伦比亚',
    tw: '哥倫比亞',
    locale: 'CO',
    code: 57,
  },
  {
    en: 'Congo',
    zh: '刚果',
    tw: '剛果',
    locale: 'CG',
    code: 242,
  },
  {
    en: 'Cook Is.',
    zh: '库克群岛',
    tw: '庫克群島',
    locale: 'CK',
    code: 682,
  },
  {
    en: 'Costa Rica',
    zh: '哥斯达黎加',
    tw: '哥斯大黎加',
    locale: 'CR',
    code: 506,
  },
  {
    en: 'Cuba',
    zh: '古巴',
    tw: '古巴',
    locale: 'CU',
    code: 53,
  },
  {
    en: 'Cyprus',
    zh: '塞浦路斯',
    tw: '賽普勒斯',
    locale: 'CY',
    code: 357,
  },
  {
    en: 'Czech Republic',
    zh: '捷克',
    tw: '捷克',
    locale: 'CZ',
    code: 420,
  },
  {
    en: 'Denmark',
    zh: '丹麦',
    tw: '丹麥',
    locale: 'DK',
    code: 45,
  },
  {
    en: 'Djibouti',
    zh: '吉布提',
    tw: '吉布提',
    locale: 'DJ',
    code: 253,
  },
  {
    en: 'Dominica Rep.',
    zh: '多米尼加共和国',
    tw: '多明尼加共和國',
    locale: 'DO',
    code: 1890,
  },
  {
    en: 'Ecuador',
    zh: '厄瓜多尔',
    tw: '厄瓜多爾',
    locale: 'EC',
    code: 593,
  },
  {
    en: 'Egypt',
    zh: '埃及',
    tw: '埃及',
    locale: 'EG',
    code: 20,
  },
  {
    en: 'EI Salvador',
    zh: '萨尔瓦多',
    tw: '薩爾瓦多',
    locale: 'SV',
    code: 503,
  },
  {
    en: 'Estonia',
    zh: '爱沙尼亚',
    tw: '愛沙尼亞',
    locale: 'EE',
    code: 372,
  },
  {
    en: 'Ethiopia',
    zh: '埃塞俄比亚',
    tw: '埃塞俄比亞',
    locale: 'ET',
    code: 251,
  },
  {
    en: 'Fiji',
    zh: '斐济',
    tw: '斐濟',
    locale: 'FJ',
    code: 679,
  },
  {
    en: 'Finland',
    zh: '芬兰',
    tw: '芬蘭',
    locale: 'FI',
    code: 358,
  },
  {
    en: 'France',
    zh: '法国',
    tw: '法國',
    locale: 'FR',
    code: 33,
    common: 'common',
  },
  {
    en: 'French Guiana',
    zh: '法属圭亚那',
    tw: '法屬圭亞那',
    locale: 'GF',
    code: 594,
  },
  {
    en: 'Gabon',
    zh: '加蓬',
    tw: '加蓬',
    locale: 'GA',
    code: 241,
  },
  {
    en: 'Gambia',
    zh: '冈比亚',
    tw: '岡比亞',
    locale: 'GM',
    code: 220,
  },
  {
    en: 'Georgia',
    zh: '格鲁吉亚',
    tw: '格魯吉亞',
    locale: 'GE',
    code: 995,
  },
  {
    en: 'Germany',
    zh: '德国',
    tw: '德國',
    locale: 'DE',
    code: 49,
    common: 'common',
  },
  {
    en: 'Ghana',
    zh: '加纳',
    tw: '加納',
    locale: 'GH',
    code: 233,
  },
  {
    en: 'Gibraltar',
    zh: '直布罗陀',
    tw: '直布羅陀',
    locale: 'GI',
    code: 350,
  },
  {
    en: 'Greece',
    zh: '希腊',
    tw: '希臘',
    locale: 'GR',
    code: 30,
  },
  {
    en: 'Grenada',
    zh: '格林纳达',
    tw: '格林納達',
    locale: 'GD',
    code: 1809,
  },
  {
    en: 'Guam',
    zh: '关岛',
    tw: '關島',
    locale: 'GU',
    code: 1671,
  },
  {
    en: 'Guatemala',
    zh: '危地马拉',
    tw: '瓜地馬拉',
    locale: 'GT',
    code: 502,
  },
  {
    en: 'Guinea',
    zh: '几内亚',
    tw: '幾內亞',
    locale: 'GN',
    code: 224,
  },
  {
    en: 'Guyana',
    zh: '圭亚那',
    tw: '圭亞那',
    locale: 'GY',
    code: 592,
  },
  {
    en: 'Haiti',
    zh: '海地',
    tw: '海地',
    locale: 'HT',
    code: 509,
  },
  {
    en: 'Honduras',
    zh: '洪都拉斯',
    tw: '洪都拉斯',
    locale: 'HN',
    code: 504,
  },
  {
    en: 'Hungary',
    zh: '匈牙利',
    tw: '匈牙利',
    locale: 'HU',
    code: 36,
  },
  {
    en: 'Iceland',
    zh: '冰岛',
    tw: '冰島',
    locale: 'IS',
    code: 354,
  },
  {
    en: 'India',
    zh: '印度',
    tw: '印度',
    locale: 'IN',
    code: 91,
    common: 'common',
  },
  {
    en: 'Indonesia',
    zh: '印尼',
    tw: '印尼',
    locale: 'ID',
    code: 62,
  },
  {
    en: 'Iran',
    zh: '伊朗',
    tw: '伊朗',
    locale: 'IR',
    code: 98,
  },
  {
    en: 'Iraq',
    zh: '伊拉克',
    tw: '伊拉克',
    locale: 'IQ',
    code: 964,
  },
  {
    en: 'Ireland',
    zh: '爱尔兰',
    tw: '愛爾蘭',
    locale: 'IE',
    code: 353,
  },
  {
    en: 'Israel',
    zh: '以色列',
    tw: '以色列',
    locale: 'IL',
    code: 972,
  },
  {
    en: 'Italy',
    zh: '意大利',
    tw: '義大利',
    locale: 'IT',
    code: 39,
  },
  {
    en: 'Ivory Coast',
    zh: '科特迪瓦',
    tw: '象牙海岸',
    locale: ' ',
    code: 225,
  },
  {
    en: 'Jamaica',
    zh: '牙买加',
    tw: '牙買加',
    locale: 'JM',
    code: 1876,
  },
  {
    en: 'Japan',
    zh: '日本',
    tw: '日本',
    locale: 'JP',
    code: 81,
    common: 'common',
  },
  {
    en: 'Jordan',
    zh: '约旦',
    tw: '約旦',
    locale: 'JO',
    code: 962,
  },
  {
    en: 'Kampuchea (Cambodia )',
    zh: '柬埔寨',
    tw: '柬埔寨',
    locale: 'KH',
    code: 855,
  },
  {
    en: 'Kazakstan',
    zh: '哈萨克斯坦',
    tw: '哈薩克斯坦',
    locale: 'KZ',
    code: 327,
  },
  {
    en: 'Kenya',
    zh: '肯尼亚',
    tw: '肯雅',
    locale: 'KE',
    code: 254,
  },
  {
    en: 'Korea',
    zh: '韩国',
    tw: '韓國',
    locale: 'KR',
    code: 82,
    common: 'common',
  },
  {
    en: 'Kuwait',
    zh: '科威特',
    tw: '科威特',
    locale: 'KW',
    code: 965,
  },
  {
    en: 'Kyrgyzstan',
    zh: '吉尔吉斯坦',
    tw: '吉爾吉斯坦',
    locale: 'KG',
    code: 331,
  },
  {
    en: 'Laos',
    zh: '老挝',
    tw: '老撾',
    locale: 'LA',
    code: 856,
  },
  {
    en: 'Latvia',
    zh: '拉脱维亚',
    tw: '拉脫維亞',
    locale: 'LV',
    code: 371,
  },
  {
    en: 'Lebanon',
    zh: '黎巴嫩',
    tw: '黎巴嫩',
    locale: 'LB',
    code: 961,
  },
  {
    en: 'Lesotho',
    zh: '莱索托',
    tw: '萊索托',
    locale: 'LS',
    code: 266,
  },
  {
    en: 'Liberia',
    zh: '利比里亚',
    tw: '利比理亞',
    locale: 'LR',
    code: 231,
  },
  {
    en: 'Libya',
    zh: '利比亚',
    tw: '利比亞',
    locale: 'LY',
    code: 218,
  },
  {
    en: 'Liechtenstein',
    zh: '列支敦士登',
    tw: '列支敦士登',
    locale: 'LI',
    code: 423,
  },
  {
    en: 'Lithuania',
    zh: '立陶宛',
    tw: '立陶宛',
    locale: 'LT',
    code: 370,
  },
  {
    en: 'Luxembourg',
    zh: '卢森堡',
    tw: '盧森堡',
    locale: 'LU',
    code: 352,
  },
  {
    en: 'Macao',
    zh: '中国澳门',
    tw: '中國澳門',
    locale: 'MO',
    code: 853,
  },
  {
    en: 'Madagascar',
    zh: '马达加斯加',
    tw: '馬達加斯加',
    locale: 'MG',
    code: 261,
  },
  {
    en: 'Malawi',
    zh: '马拉维',
    tw: '馬拉維',
    locale: 'MW',
    code: 265,
  },
  {
    en: 'Malaysia',
    zh: '马来西亚',
    tw: '馬來西亞',
    locale: 'MY',
    code: 60,
  },
  {
    en: 'Maldives',
    zh: '马尔代夫',
    tw: '馬爾代夫',
    locale: 'MV',
    code: 960,
  },
  {
    en: 'Mali',
    zh: '马里',
    tw: '馬里',
    locale: 'ML',
    code: 223,
  },
  {
    en: 'Malta',
    zh: '马耳他',
    tw: '馬爾他',
    locale: 'MT',
    code: 356,
  },
  {
    en: 'Mariana Is',
    zh: '马里亚那群岛',
    tw: '馬里亞那群島',
    locale: ' ',
    code: 1670,
  },
  {
    en: 'Martinique',
    zh: '马提尼克',
    tw: '馬提尼克',
    locale: ' ',
    code: 596,
  },
  {
    en: 'Mauritius',
    zh: '毛里求斯',
    tw: '毛里求斯',
    locale: 'MU',
    code: 230,
  },
  {
    en: 'Mexico',
    zh: '墨西哥',
    tw: '墨西哥',
    locale: 'MX',
    code: 52,
  },
  {
    en: 'Moldova, Republic of',
    zh: '摩尔多瓦',
    tw: '莫爾達瓦',
    locale: 'MD',
    code: 373,
  },
  {
    en: 'Monaco',
    zh: '摩纳哥',
    tw: '摩納哥',
    locale: 'MC',
    code: 377,
  },
  {
    en: 'Mongolia',
    zh: '蒙古',
    tw: '蒙古',
    locale: 'MN',
    code: 976,
  },
  {
    en: 'Montserrat Is',
    zh: '蒙特塞拉特岛',
    tw: '蒙特塞拉特島',
    locale: 'MS',
    code: 1664,
  },
  {
    en: 'Morocco',
    zh: '摩洛哥',
    tw: '摩洛哥',
    locale: 'MA',
    code: 212,
  },
  {
    en: 'Mozambique',
    zh: '莫桑比克',
    tw: '莫三比克',
    locale: 'MZ',
    code: 258,
  },
  {
    en: 'Namibia',
    zh: '纳米比亚',
    tw: '納米比亞',
    locale: 'NA',
    code: 264,
  },
  {
    en: 'Nauru',
    zh: '瑙鲁',
    tw: '瑙魯',
    locale: 'NR',
    code: 674,
  },
  {
    en: 'Nepal',
    zh: '尼泊尔',
    tw: '尼泊爾',
    locale: 'NP',
    code: 977,
  },
  {
    en: 'Netheriands Antilles',
    zh: '荷属安的列斯',
    tw: '荷屬安的列斯',
    locale: ' ',
    code: 599,
  },
  {
    en: 'Netherlands',
    zh: '荷兰',
    tw: '荷蘭',
    locale: 'NL',
    code: 31,
  },
  {
    en: 'New Zealand',
    zh: '新西兰',
    tw: '新西蘭',
    locale: 'NZ',
    code: 64,
  },
  {
    en: 'Nicaragua',
    zh: '尼加拉瓜',
    tw: '尼加拉瓜',
    locale: 'NI',
    code: 505,
  },
  {
    en: 'Niger',
    zh: '尼日尔',
    tw: '尼日爾',
    locale: 'NE',
    code: 227,
  },
  {
    en: 'Nigeria',
    zh: '尼日利亚',
    tw: '尼日利亞',
    locale: 'NG',
    code: 234,
  },
  {
    en: 'North Korea',
    zh: '朝鲜',
    tw: '朝鮮',
    locale: 'KP',
    code: 850,
  },
  {
    en: 'Norway',
    zh: '挪威',
    tw: '挪威',
    locale: 'NO',
    code: 47,
  },
  {
    en: 'Oman',
    zh: '阿曼',
    tw: '阿曼',
    locale: 'OM',
    code: 968,
  },
  {
    en: 'Pakistan',
    zh: '巴基斯坦',
    tw: '巴基斯坦',
    locale: 'PK',
    code: 92,
  },
  {
    en: 'Panama',
    zh: '巴拿马',
    tw: '巴拿馬',
    locale: 'PA',
    code: 507,
  },
  {
    en: 'Papua New Cuinea',
    zh: '巴布亚新几内亚',
    tw: '巴布亞新幾內亞',
    locale: 'PG',
    code: 675,
  },
  {
    en: 'Paraguay',
    zh: '巴拉圭',
    tw: '巴拉圭',
    locale: 'PY',
    code: 595,
  },
  {
    en: 'Peru',
    zh: '秘鲁',
    tw: '秘魯',
    locale: 'PE',
    code: 51,
  },
  {
    en: 'Philippines',
    zh: '菲律宾',
    tw: '菲律賓',
    locale: 'PH',
    code: 63,
  },
  {
    en: 'Poland',
    zh: '波兰',
    tw: '波蘭',
    locale: 'PL',
    code: 48,
  },
  {
    en: 'French Polynesia',
    zh: '法属玻利尼西亚',
    tw: '法屬玻利尼西亞',
    locale: 'PF',
    code: 689,
  },
  {
    en: 'Portugal',
    zh: '葡萄牙',
    tw: '葡萄牙',
    locale: 'PT',
    code: 351,
  },
  {
    en: 'Puerto Rico',
    zh: '波多黎各',
    tw: '波多黎各',
    locale: 'PR',
    code: 1787,
  },
  {
    en: 'Qatar',
    zh: '卡塔尔',
    tw: '卡塔爾',
    locale: 'QA',
    code: 974,
  },
  {
    en: 'Reunion',
    zh: '留尼汪',
    tw: '留尼汪',
    locale: ' ',
    code: 262,
  },
  {
    en: 'Romania',
    zh: '罗马尼亚',
    tw: '羅馬尼亞',
    locale: 'RO',
    code: 40,
  },
  {
    en: 'Russia',
    zh: '俄罗斯',
    tw: '俄羅斯',
    locale: 'RU',
    code: 7,
  },
  {
    en: 'Saint Lueia',
    zh: '圣卢西亚',
    tw: '聖盧西亞',
    locale: 'LC',
    code: 1758,
  },
  {
    en: 'Saint Vincent',
    zh: '圣文森特岛',
    tw: '聖文森特島',
    locale: 'VC',
    code: 1784,
  },
  {
    en: 'Samoa Eastern',
    zh: '东萨摩亚(美)',
    tw: '東薩摩亞(美)',
    locale: ' ',
    code: 684,
  },
  {
    en: 'Samoa Western',
    zh: '西萨摩亚',
    tw: '西薩摩亞',
    locale: ' ',
    code: 685,
  },
  {
    en: 'San Marino',
    zh: '圣马力诺',
    tw: '聖馬力諾',
    locale: 'SM',
    code: 378,
  },
  {
    en: 'Sao Tome and Principe',
    zh: '圣多美和普林西比',
    tw: '聖多美和普林西比',
    locale: 'ST',
    code: 239,
  },
  {
    en: 'Saudi Arabia',
    zh: '沙特阿拉伯',
    tw: '沙特阿拉伯',
    locale: 'SA',
    code: 966,
  },
  {
    en: 'Senegal',
    zh: '塞内加尔',
    tw: '塞內加爾',
    locale: 'SN',
    code: 221,
  },
  {
    en: 'Seychelles',
    zh: '塞舌尔',
    tw: '塞舌耳',
    locale: 'SC',
    code: 248,
  },
  {
    en: 'Sierra Leone',
    zh: '塞拉利昂',
    tw: '塞拉里昂',
    locale: 'SL',
    code: 232,
  },
  {
    en: 'Singapore',
    zh: '新加坡',
    tw: '新加坡',
    locale: 'SG',
    code: 65,
    common: 'common',
  },
  {
    en: 'Slovakia',
    zh: '斯洛伐克',
    tw: '斯洛伐克',
    locale: 'SK',
    code: 421,
  },
  {
    en: 'Slovenia',
    zh: '斯洛文尼亚',
    tw: '斯洛文尼亞',
    locale: 'SI',
    code: 386,
  },
  {
    en: 'Solomon Is',
    zh: '所罗门群岛',
    tw: '所羅門群島',
    locale: 'SB',
    code: 677,
  },
  {
    en: 'Somali',
    zh: '索马里',
    tw: '索馬里',
    locale: 'SO',
    code: 252,
  },
  {
    en: 'South Africa',
    zh: '南非',
    tw: '南非',
    locale: 'ZA',
    code: 27,
  },
  {
    en: 'Spain',
    zh: '西班牙',
    tw: '西班牙',
    locale: 'ES',
    code: 34,
  },
  {
    en: 'Sri Lanka',
    zh: '斯里兰卡',
    tw: '斯里蘭卡',
    locale: 'LK',
    code: 94,
  },
  {
    en: 'St.Lucia',
    zh: '圣卢西亚',
    tw: '聖盧西亞',
    locale: 'LC',
    code: 1758,
  },
  {
    en: 'St.Vincent',
    zh: '圣文森特',
    tw: '聖文森特',
    locale: 'VC',
    code: 1784,
  },
  {
    en: 'Sudan',
    zh: '苏丹',
    tw: '蘇丹',
    locale: 'SD',
    code: 249,
  },
  {
    en: 'Suriname',
    zh: '苏里南',
    tw: '蘇里南',
    locale: 'SR',
    code: 597,
  },
  {
    en: 'Swaziland',
    zh: '斯威士兰',
    tw: '斯威士蘭',
    locale: 'SZ',
    code: 268,
  },
  {
    en: 'Sweden',
    zh: '瑞典',
    tw: '瑞典',
    locale: 'SE',
    code: 46,
  },
  {
    en: 'Switzerland',
    zh: '瑞士',
    tw: '瑞士',
    locale: 'CH',
    code: 41,
  },
  {
    en: 'Syria',
    zh: '叙利亚',
    tw: '敘利亞',
    locale: 'SY',
    code: 963,
  },
  {
    en: 'Tajikstan',
    zh: '塔吉克斯坦',
    tw: '塔吉克斯坦',
    locale: 'TJ',
    code: 992,
  },
  {
    en: 'Tanzania',
    zh: '坦桑尼亚',
    tw: '坦桑尼亞',
    locale: 'TZ',
    code: 255,
  },
  {
    en: 'Thailand',
    zh: '泰国',
    tw: '泰國',
    locale: 'TH',
    code: 66,
  },
  {
    en: 'Togo',
    zh: '多哥',
    tw: '多哥',
    locale: 'TG',
    code: 228,
  },
  {
    en: 'Tonga',
    zh: '汤加',
    tw: '湯加',
    locale: 'TO',
    code: 676,
  },
  {
    en: 'Trinidad and Tobago',
    zh: '特立尼达和多巴哥',
    tw: '特立尼達和多巴哥',
    locale: 'TT',
    code: 1809,
  },
  {
    en: 'Tunisia',
    zh: '突尼斯',
    tw: '突尼斯',
    locale: 'TN',
    code: 216,
  },
  {
    en: 'Turkey',
    zh: '土耳其',
    tw: '土耳其',
    locale: 'TR',
    code: 90,
  },
  {
    en: 'Turkmenistan',
    zh: '土库曼斯坦',
    tw: '土庫曼斯坦',
    locale: 'TM',
    code: 993,
  },
  {
    en: 'Uganda',
    zh: '乌干达',
    tw: '烏干達',
    locale: 'UG',
    code: 256,
  },
  {
    en: 'Ukraine',
    zh: '乌克兰',
    tw: '烏克蘭',
    locale: 'UA',
    code: 380,
  },
  {
    en: 'United Arab Emirates',
    zh: '阿拉伯联合酋长国',
    tw: '阿拉伯聯合酋長國',
    locale: 'AE',
    code: 971,
  },
  {
    en: 'United Kiongdom',
    zh: '英国',
    tw: '英國',
    locale: 'GB',
    code: 44,
    common: 'common',
  },
  {
    en: 'Uruguay',
    zh: '乌拉圭',
    tw: '烏拉圭',
    locale: 'UY',
    code: 598,
  },
  {
    en: 'Uzbekistan',
    zh: '乌兹别克斯坦',
    tw: '烏茲別克斯坦',
    locale: 'UZ',
    code: 233,
  },
  {
    en: 'Venezuela',
    zh: '委内瑞拉',
    tw: '委內瑞拉',
    locale: 'VE',
    code: 58,
  },
  {
    en: 'Vietnam',
    zh: '越南',
    tw: '越南',
    locale: 'VN',
    code: 84,
  },
  {
    en: 'Yemen',
    zh: '也门',
    tw: '葉門',
    locale: 'YE',
    code: 967,
  },
  {
    en: 'Yugoslavia',
    zh: '南斯拉夫',
    tw: '南斯拉夫',
    locale: 'YU',
    code: 381,
  },
  {
    en: 'Zimbabwe',
    zh: '津巴布韦',
    tw: '津巴布韋',
    locale: 'ZW',
    code: 263,
  },
  {
    en: 'Zaire',
    zh: '扎伊尔',
    tw: '扎伊爾',
    locale: 'ZR',
    code: 243,
  },
  {
    en: 'Zambia',
    zh: '赞比亚',
    tw: '讚比亞',
    locale: 'ZM',
    code: 260,
  },
]
exports.countryCode = countryCode
